export function initMetaPixel() {
  if (typeof window === 'undefined') return
  ;(function (f: any, b: any, e: any, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e)
    t.async = !0
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', '1223874073163285')
  window.fbq('track', 'PageView')
}

export function handleAddToCart(e: React.MouseEvent<HTMLAnchorElement>) {
  e.preventDefault()

  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart')
  }

  // Small delay to ensure pixel fires before navigation
  const href = (e.currentTarget as HTMLAnchorElement).href
  setTimeout(() => {
    window.open(href, '_blank', 'noopener,noreferrer')
  }, 300)
}

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}
